import { Divider, Typography } from "antd";
const { Text } = Typography;
const Heading = ({ title }) => {
  return (
    <>
      <Text style={{ fontSize: "1.2em" }}>{title}</Text>
    </>
  );
};
export default Heading;
